import {getViewportHeight} from '../utils/utils';
export default {
    methods: {
        getViewportHeight
    }
}